import API from "@/constant/API";
import axiosInstance from "@/utils/axios";
import { getUrlParams } from "@/utils/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DetailHeader from "../components/DetailHeader";
import { Stack,Box } from "@mui/material";
import CopyButton from "@/components/CopyButton";
import classes from "./css/index.module.less";

function DebtPaymentDetail() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => {
    const sn = getUrlParams('sn');
    if (sn) {
      _initData(sn);
    }
  }, []);

  const _initData = async (sn) => {
    const res = await axiosInstance.post(API.DEBT_PAYMENT_DETAIL, {
      sn: sn
    });
    setData(res);
  }

  if (!data) return null;

  return (
    <>
      <DetailHeader icon={''} title={data.businessTypeDisplayName} titleIcon={''} amount={data.billAmount} currency={data.billCurrency} />

      {data.assetsList?.map((item, idx) => <Stack key={idx} direction={'row'}>
        <div>{item.varietyCode}</div>
        <div>{item.amount}</div>
      </Stack>)}

      <Box className={classes['transaction-detail-wrap']}>
        <div className={'h4'}>{t('transaction_detail')}</div>
        <Stack direction={'column'} gap={'6px'}>
          <div className={"small"}>{t('transaction_date')}</div>
          <div className={'text-primary'}>{data.repaymentTime}</div>
        </Stack>
        <Stack direction={'column'} gap={'6px'}>
          <div className={"small"}>{t('transaction_id')}</div>
          <Stack direction={'row'} alignItems={'center'}>
            <span className={'text-primary'}>{data.sn}</span>
            <CopyButton value={data.sn} size={18}/>
          </Stack>
        </Stack>
      </Box>
    </>
  )
}

export default DebtPaymentDetail
